<template>
  <div :class="jel_getClassObject(content)">
    <div v-if="produitCollection" class="themeFonce background-entete">
      <b-row align-h="between" class="p-0 m-0">
        <!-- TODO: Avec un b-row on s'attend à un b-col. À réviser -->
        <div class="p-0 m-0">
          <div class="d-lg-none">
            <b-button
              class="bouton-retour rounded-0 p-0 m-0 border-0 shadow-none"
              @click="jel_traiterRetour()"
            >
              <svg-icon
                class="svg-icone-retour rotation180"
                icon-name="fleche-droite-mini-lien"
              ></svg-icon>
            </b-button>
          </div>
          <LienRetour class="d-none d-lg-flex pt-1 pl-1" :content="{ appareil: 'tous' }" />
        </div>
        <div class="d-flex justify-content-end">
          <svg-icon class="svg-icone" icon-name="icone-loop" />
          <div>
            <b-form-input
              v-model="filtre.titre"
              class="rounded-0 border-0 body-5 form-control"
              :class="[!isFiltre ? 'recherche-sans-texte' : 'recherche']"
              debounce="500"
              :placeholder="$t('messageComponent.recherche')"
            ></b-form-input>
          </div>

          <b-button
            v-if="isFiltre"
            class="rounded-0 p-0 m-0 border-0 shadow-none"
            @click="resetFiltre()"
          >
            <svg-icon class="svg-icone" icon-name="icone-fermer-recherche" />
          </b-button>
        </div>
      </b-row>
      <b-row align-h="between" class="mr-2 mr-md-3">
        <b-col :cols="$isMobile() ? 9 : 12">
          <h2
            :class="description ? 'titre-entete-avec-description' : 'titre-entete'"
            v-html="titre"
          />
          <p v-if="description" class="texte-entete graphik_regular" v-html="`${description}`" />
        </b-col>
      </b-row>
    </div>
    <div
      v-if="isConsentementRequis && !isConsentant"
      class="mw-100 container-produit-collection-without-consent container-fluid"
    >
      <div class="pl-2 py-2 col texte-consentement" v-html="getMessageConsentement()" />
    </div>
    <b-container
      v-else-if="produitCollection && arrayProduitFiltre"
      fluid
      class="mw-100 container-produit-collection"
    >
      <b-row align-h="between">
        <b-col class="ml-2 my-2 resultats">
          {{
            arrayProduitFiltre.length > 1
              ? $tc('messageComponent.resultat', arrayProduitFiltre.length)
              : $tc('messageComponent.resultat', 1, { n: arrayProduitFiltre.length })
          }}
        </b-col>
        <!-- <p class="d-flex justify-content-end mr-5">{{ $tc('messageComponent.trierPar') }}</p> -->
      </b-row>
      <b-row id="collectionProduits" class="collection-produits mw-100 m-0 mt-0">
        <b-col
          v-for="produit in getArrayProduitFiltre"
          :key="produit['@id']"
          class="col-12 col-sm-6 col-md-4 col-xxl-3 p-1"
        >
          <mq-layout mq="xs">
            <MediaImageLogoProduitCasinoLarge
              :content="{ produit: produit }"
              class="carte-logo-fixe liste-1-colonne"
            />
          </mq-layout>
          <mq-layout mq="sm+">
            <CarteProduitCasino
              :content="{ produit: produit, formatCarte: '5x6', isCollectionCasino: true }"
            />
          </mq-layout>
        </b-col>
      </b-row>
      <b-row v-if="arrayProduitFiltre.length !== 0" class="my-2">
        <b-col class="mt-1 text-center jeux-affiche">
          {{
            arrayProduitFiltre.length == 1
              ? $tc('messageComponent.jeuxAffiches', 1, {
                  nMin: nbProduitsAffiche,
                  nMax: arrayProduitFiltre.length,
                })
              : $tc('messageComponent.jeuxAffiches', 2, {
                  nMin: nbProduitsAffiche,
                  nMax: arrayProduitFiltre.length,
                })
          }}
        </b-col>
      </b-row>
      <b-row class="pb-3">
        <b-col class="d-flex justify-content-center">
          <button
            v-if="nbProduitsAffiche < arrayProduitFiltre.length"
            class="voir-plus px-0 lienAsset"
            @click="augmenterProduitsAffiche()"
          >
            {{ $tc('messageComponent.voirPlus') }}
          </button>
        </b-col>
      </b-row>
    </b-container>
    <div v-else>
      <div class="d-flex justify-content-center vh-100">
        <b-spinner
          variant="primary"
          class="align-self-center"
          type="grow"
          :label="$t('chargement')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { bus } from '@/main';
import i18n from '@/js/i18n';
import { capitalizeFirstLetter } from '@/helpers/StringHelpers';
import { PageMappingCasino } from '@/helpers/PageMappingHelpers';
import { gtmCustomEventByVendor } from '@/helpers/ConsentHelpers';

import CarteProduitCasino from '@/components/casino/carte/CarteProduitCasino';
import LienRetour from '@/components/base/LienRetour';
import MediaImageLogoProduitCasinoLarge from '@/components/casino/media/image/MediaImageLogoProduitCasinoLarge';

export default {
  name: 'CollectionCasino',
  components: {
    CarteProduitCasino,
    LienRetour,
    MediaImageLogoProduitCasinoLarge,
  },
  props: {
    content: { type: Object, required: true },
  },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          didomiFavoris:
            'Les jeux favoris utilise des témoins de personnalisation dont vous avez refusé l’utilisation. Pour voir les jeux que vous avez sélectionné en favoris, vous devez accepter tous les témoins de personnalisation. Ces témoins servent à améliorer votre expérience de navigation en enregistrant certaines de vos préférences.',
          didomiRecents:
            'Joués récemment utilise des témoins de personnalisation dont vous avez refusé l’utilisation. Pour voir les jeux joués récemment, vous devez accepter tous les témoins de personnalisation. Ces témoins servent à améliorer votre expérience de navigation en enregistrant certaines de vos préférences.',
          filtrer: 'Filtrer',
          jeuxAffiches: '{nMin} sur {nMax} jeu affiché | {nMin} sur {nMax} jeux affichés',
          recherche: 'Recherche',
          rechercheEnCours: 'Recherche en cours...',
          resultat: '{n} résultat | {n} résultats',
          trierPar: 'Trier par: popularité',
          voirPlus: 'Voir plus',
        },
      },
      en: {
        messageComponent: {
          didomiFavoris:
            'Favourites games uses personalization cookies that you have deactivated. To view your favorites games, you must accept all personalization cookies. These cookies are used to improve your browsing experience by saving some of your preferences.',
          didomiRecents:
            'Recently played uses personalization cookies that you have deactivated. To view recently played games, you must accept all personalization cookies. These cookies are used to improve your browsing experience by saving some of your preferences.',
          filtrer: 'Filter',
          jeuxAffiches: 'Displaying {nMin} of {nMax} game | Displaying {nMin} of {nMax} games',
          recherche: 'Search',
          rechercheEnCours: 'Searching...',
          resultat: '{n} result | {n} results',
          trierPar: 'Sort by: popularity',
          voirPlus: 'Show more',
        },
      },
    },
  },
  data() {
    return {
      filtre: {
        titre: '',
      },
      idProduitCollection: this.$route.params.idProduitCollection,
      nbProduitsAjouter: 60,
      nbProduitsAffiche: 0,
    };
  },
  computed: {
    ...mapGetters({
      getByNameI18n: 'produitCollection/getByNameI18n',
      getArrayProduitByUuidProduitCollection:
        'produitCollection/getArrayProduitByUuidProduitCollection',
    }),
    produitCollection() {
      let prdCollection = null;
      if (this.idProduitCollection) {
        prdCollection = this.getByNameI18n(this.idProduitCollection);
        if (prdCollection === undefined) {
          // window.location.href = PageMappingErreurSeveur[404].siteUrl;
          this.returnToCasinoHome();
        }
      }
      return prdCollection;
    },
    titre() {
      return i18n.locale == 'en'
        ? this.produitCollection.titreCollectionEn
        : this.produitCollection.titreCollectionFr;
    },

    description() {
      const desc = this.produitCollection.descriptionCollection;
      const pattern = /<[\\/]?p>/g;
      const descModifie = desc ? desc.replace(new RegExp(pattern), '') : null;
      return descModifie;
    },
    arrayProduit() {
      return this.getArrayProduitByUuidProduitCollection(this.produitCollection['@id']);
    },
    isFiltre() {
      // Éventuellement, ajouter tous les autres filtres utilisateurs possibles
      return this.filtre.titre;
    },

    arrayProduitFiltre() {
      if (this.isFiltre) {
        const titreLocale = `titre${capitalizeFirstLetter(i18n.locale)}`;

        const arrayProduitFiltreNonTrie = this.arrayProduit.filter((produit) => {
          if (
            this.filtre.titre &&
            !produit[titreLocale].toLowerCase().includes(this.filtre.titre.toLowerCase())
          )
            return false;

          return true;
        });

        return arrayProduitFiltreNonTrie;
      }
      return this.arrayProduit;
    },

    resultat() {
      if (!this.arrayProduit) {
        return this.$t('messageComponent.rechercheEnCours');
      }
      return this.$tc('messageComponent.resultat', this.arrayProduit.length);
    },
    getArrayProduitFiltre() {
      this.verifierNombreAfficher();
      if (this.arrayProduitFiltre.length > this.nbProduitsAffiche) {
        return this.arrayProduitFiltre.slice(0, this.nbProduitsAffiche);
      }
      if (this.isFiltre) this.gaTrackEvent(this.arrayProduitFiltre.length);

      return this.arrayProduitFiltre;
    },
    isConsentementRequis() {
      if (this.produitCollection) {
        return (
          this.produitCollection['@name'] === 'recents' ||
          this.produitCollection['@name'] === 'favoris'
        );
      }
      return false;
    },
    isConsentant() {
      return this.$store.state.consentement.consentement.preferences;
    },
  },
  mounted() {
    const self = this;
    // Laisser le temps à produitCollection d'obtenir ses informations
    setTimeout(() => {
      self.busEmitUrlAutreLangue();
    }, 3000);
  },
  activated() {
    this.idProduitCollection = this.$route.params.idProduitCollection;
    const self = this;
    this.$nextTick(() => {
      self.busEmitUrlAutreLangue();
      self.resetFiltre();
    });
  },
  methods: {
    gaTrackEvent(nbProduits = null) {
      const event = 'ga-rc-click';
      const categorie = 'RC - Recherche collection';
      const libelle = `Recherche ${this.filtre.titre} - ${nbProduits} produits`;
      const emplacement = `Collection ${this.titre}`;

      // Ajout datalayer pour ajouter statistiques Event click vers Google Analytics
      gtmCustomEventByVendor(process.env.VUE_APP_IAB_ID_ANALYTICS, {
        event,
        categorie,
        emplacement,
        libelle,
      });
    },
    busEmitUrlAutreLangue() {
      const pathAutreLangue = `${
        (i18n.locale == 'fr' ? '/en' : '/fr') +
        this.$store.getters['routes/getUrlFromWebsitePath'](
          PageMappingCasino.CASINO_COLLECTION.siteUrl
        )
      }/${i18n.locale == 'fr' ? this.produitCollection.nameEn : this.produitCollection.name}`;

      bus.$emit('urlAutreLangue', pathAutreLangue);
    },
    resetFiltre() {
      this.filtre.titre = '';
    },
    augmenterProduitsAffiche() {
      if (this.nbProduitsAffiche + this.nbProduitsAjouter >= this.arrayProduitFiltre.length) {
        this.nbProduitsAffiche = this.arrayProduitFiltre.length;
      } else {
        this.nbProduitsAffiche += this.nbProduitsAjouter;
      }
    },
    verifierNombreAfficher() {
      if (
        this.arrayProduitFiltre.length > 0 &&
        this.arrayProduitFiltre.length < this.nbProduitsAjouter
      ) {
        // il y a moins de 60 produits, tous les afficher
        this.nbProduitsAffiche = this.arrayProduitFiltre.length;
      } else if (
        this.nbProduitsAffiche == 0 ||
        (this.arrayProduitFiltre.length > this.nbProduitsAjouter &&
          this.nbProduitsAffiche < this.nbProduitsAjouter)
      ) {
        // il y a plus de résultats que le nombre max par page donc afficher le nombre max par page
        this.nbProduitsAffiche = this.nbProduitsAjouter;
      }
    },

    returnToCasinoHome() {
      const uriReturn = this.$store.getters['routes/getUrlFromWebsitePath'](
        PageMappingCasino.CASINO_ACCUEIL.siteUrl
      );
      this.$router.push(uriReturn).catch(() => {
        console.log('Route inexistante: ', uriReturn);
      });
    },
    getMessageConsentement() {
      if (this.produitCollection['@name'] === 'recents') {
        return this.$i18n.t('messageComponent.didomiRecents');
      }
      if (this.produitCollection['@name'] === 'favoris') {
        return this.$i18n.t('messageComponent.didomiFavoris');
      }
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
.background-entete {
  background-color: $noir-casino;
}

.titre-entete {
  color: $couleur-texte-theme-fonce !important;
  background-color: transparent !important;
  font-size: 24px;
  line-height: 26px;
  margin-top: 40px;
  margin-left: 16px;
  margin-bottom: 24px;

  padding-bottom: 0;

  @include media-breakpoint-up(md) {
    font-size: 24px;
    line-height: 26px;
    margin-left: 24px;
  }
  @include media-breakpoint-up(xl) {
    font-size: 42px;
    line-height: 44px;
    margin-left: 32px;
    margin-bottom: 32px;
  }

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.titre-entete-avec-description {
  @extend .titre-entete;
  @include media-breakpoint-up(xl) {
    margin-bottom: 12px;
    width: 100%;
  }
  margin-bottom: 8px;
  width: 80%;
}

.texte-entete {
  @extend .titre-entete;
  font-size: 13px;
  line-height: 16px;
  margin-left: 16px;
  margin-top: 0;
  margin-bottom: 12px;
  width: 85%;

  @include media-breakpoint-up(md) {
    margin-left: 24px;
    -webkit-line-clamp: 1;
    width: 75%;
  }
  @include media-breakpoint-up(xl) {
    font-size: 15px;
    line-height: 20px;
    margin-left: 32px;
    margin-bottom: 16px;
    width: 100%;
  }

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.form-control:focus {
  box-shadow: none;
}

.svg-icone {
  background: white;
  border: none;
  width: 48px;
  height: 48px;
}

.bouton-retour {
  background-color: transparent !important;
  width: 48px;
  height: 48px;
}

.svg-icone-retour {
  background-color: transparent !important;
  width: 16px;
  height: 16px;
  color: $couleur-blanc;
}

.recherche {
  border: none;
  width: 135px !important;
  @media screen and (min-width: 360px) {
    width: 210px !important;
  }
  @media screen and (min-width: 375px) {
    width: 225px !important;
  }
  @media screen and (min-width: 390px) {
    width: 245px !important;
  }
  @media screen and (min-width: 410px) {
    width: 265px !important;
  }
  @media screen and (min-width: 415px) {
    width: 270px !important;
  }
  height: 48px;
  background: white !important;
}
.recherche-sans-texte {
  border: none;
  width: 184px !important;
  @media screen and (min-width: 360px) {
    width: 260px !important;
  }
  @media screen and (min-width: 375px) {
    width: 275px !important;
  }
  @media screen and (min-width: 390px) {
    width: 290px !important;
  }
  @media screen and (min-width: 410px) {
    width: 315px !important;
  }
  @media screen and (min-width: 415px) {
    width: 319px !important;
  }
  height: 48px;
  background: white !important;
}
.voir-plus {
  padding-bottom: 0;
  background-color: transparent;
  border: none;
  font-family: $font-graphik-medium;
  font-size: 15px;
}
.jeux-affiche {
  font-size: 15px;
  line-height: 17px;
}
.container-produit-collection {
  background: white;
}
.container-produit-collection-without-consent {
  background: $blanc-casino;
}
.texte-consentement {
  color: $noir-casino;
  max-width: 800px;
}
.resultats {
  color: $gris-fonce-casino;
}
</style>
